import Button from '@berlitz/button'
import { Grid } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

export const Body = styled(Grid)`
  padding: 0;
`

/* TODO: remove rotate when left arrow icon is uploaded */
export const Back = styled(Button)`
  padding: ${({ theme }) => `0 ${theme.space.xs} 0 ${theme.space.xxs}`};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  border: 0;
  margin-bottom: ${({ theme }) => theme.space.md};
  svg {
    color: ${({ theme }) => theme.colors.brandPrimaryContrast};
    transform: rotate(180deg);
    margin-top: ${({ theme }) => theme.space.xxxs};
  }
  &:focus {
    outline: 0;
  }
`
